import { NavigationExtras } from '@angular/router';
import { Action } from '@ngrx/store';

export class RouterNavigate implements Action {
    readonly type = RouterActionTypes.ROUTER_NAVIGATE;

    constructor(
        public payload: {
            path: any[];
            query?: object;
            extras?: NavigationExtras
        }
    ) {
    }
}

export class RouterNavigateByUrl implements Action {
    readonly type = RouterActionTypes.ROUTER_NAVIGATE_BY_URL;

    constructor(public payload: string) {
    }
}

export class RouterBack implements Action {
    readonly type = RouterActionTypes.ROUTER_BACK;
}

export class RouterForward implements Action {
    readonly type = RouterActionTypes.ROUTER_FORWARD;
}

export class RouterNavigateToTourStop implements Action {
    readonly type = RouterActionTypes.ROUTER_NAVIGATE_T0_TOUR_STOP;
}

export class RouterNavigateToTourStopDetail implements Action {
    readonly type = RouterActionTypes.ROUTER_NAVIGATE_T0_TOUR_STOP_DETAIL;
}

export enum RouterActionTypes {
    'ROUTER_NAVIGATE' = 'ROUTER_NAVIGATE',
    'ROUTER_NAVIGATE_BY_URL' = 'ROUTER_NAVIGATE_BY_URL',
    'ROUTER_BACK' = 'ROUTER_BACK',
    'ROUTER_FORWARD' = 'ROUTER_FORWARD',
    'ROUTER_NAVIGATE_T0_TOUR_STOP' = 'ROUTER_NAVIGATE_T0_TOUR_STOP',
    'ROUTER_NAVIGATE_T0_TOUR_STOP_DETAIL' = 'ROUTER_NAVIGATE_T0_TOUR_STOP_DETAIL',
}

export type RouterActions = RouterNavigate | RouterNavigateByUrl | RouterBack | RouterForward | RouterNavigateToTourStop | RouterNavigateToTourStopDetail;
